<script setup>
/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { ref, nextTick, defineProps, defineExpose } from 'vue';

/*==================================================================*/
/*================ IMPORTS COMPONENTES =============================*/
/*==================================================================*/

import ModalBase from '@/components/v2/base/ModalBase/ModalBase.vue';

/*==================================================================*/
/*================== PROPS =========================================*/
/*==================================================================*/

const props = defineProps({
    maxWidth: {
        type: String,
        default: '400'
    }
});

/*==================================================================*/
/*================== MODAL BASE REF ================================*/
/*==================================================================*/

const modalBaseRef = ref(null);

/*==================================================================*/
/*================== ABRIR MODAL ===================================*/
/*==================================================================*/

const abrirModal = async () => {

    await modalBaseRef.value?.abrirModal();
    await nextTick();

};

/*==================================================================*/
/*================== FECHAR MODAL ==================================*/
/*==================================================================*/

const fecharModal = async () => {

    await modalBaseRef.value?.fecharModal();
    await nextTick();

};

/*==================================================================*/
/*================== EXPOSE ========================================*/
/*==================================================================*/

defineExpose({ abrirModal, fecharModal });

</script>

<template>

    <ModalBase
        ref="modalBaseRef"
        persistent
        :max-width="props.maxWidth"
    >

        <v-card class="c-modal-dialogo">

            <v-card-title class="c-modal-dialogo-header">
                <slot name="header"></slot>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="c-modal-dialogo-body">
                <slot name="body"></slot>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="c-modal-dialogo-footer">
                <slot name="footer"></slot>
            </v-card-actions>

        </v-card>

    </ModalBase>

</template>

<style scoped>

.c-modal-dialogo-header{
    font-size: 20px;
    font-weight: bold;
}

.c-modal-dialogo-body{
    padding-top: 16px !important;
}

.c-modal-dialogo-footer{
    padding: 16px;
    gap: 8px;
}

</style>
